import { blue, red } from '@mui/material/colors';
import { defaultTheme } from "react-admin";

// in src/theme.js
export const theme = {
    // ... other theme settings
    palette: {
        ...defaultTheme,
        // Set the primary color for buttons, active elements, etc.
        primary: {
            main: '#4f3cc9', // A custom purple shade
            // light, dark, and contrastText are calculated automatically 
        },
        // Set the secondary color, often used for the App Bar
        secondary: {
            main: blue[800],
        },
        // Set the mode (light or dark)
        mode: 'light', 
        // Customize the background colors
        background: {
            default: '#f3f4f6', // Main page background
            paper: '#ffffff',    // Card/Paper background
        },
        // Customize error, warning, info, success colors as needed
        error: red,
    },
    components: {
       
         MuiTextField: {
        styleOverrides: {
            root: {
            width: "100%", // ensures full width inputs
            },
        },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                transform: 'translate(14px, 16px) scale(1)', // Adjust label position
                '&.MuiInputLabel-shrink': {
                    transform: 'translate(14px, -9px) scale(0.75)',
                },
                },
            },
            },
            MuiOutlinedInput: {
            styleOverrides: {
                input: {
                padding: '14px', // Ensures text stays centered vertically
                },
            },
        },
        RaMenuItemLink: {
            styleOverrides: {
                root: {
                    // Optional: invisible border to prevent position shift on hover/active
                    borderLeft: '3px solid transparent', 
                    // Style for the active state
                    '&.RaMenuItemLink-active': {
                        borderLeft: '10px solid #4f3cc9', // Example highlight
                        backgroundColor: 'rgba(79, 60, 201, 0.1)', // Example background
                    },
                },
            },
        },
    },
};